import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type AddActivityMutationData} from './add-activity';

export function addActivityPatcher(data: AddActivityMutationData): RestTypeWithTypename<AddActivityMutationData> {
    return {
        __typename: 'AddActivityMutation',
        action: {
            __typename: 'AddActivityMutationAction',
            ...data.action,
        },
    };
}
